export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-path/index.js
// module id = TASy
// module chunks = 0